import programApi from '@/api/main-program'
import subProgramApi from '@/api/sub-program'

export default [
  {
    path: '/subject-activities',
    name: 'subject-activity',
    meta: { requiresAuth: true },
    component: () => import('@/pages/subject-activity/index.vue'),
    props: route => ({
      programs: route.params.programs,
      subPrograms: route.params.subPrograms
    }),
    beforeEnter: async (to, from, next) => {
      let resources = await Promise.all([
        programApi.get({ params: { perPage: -1 } }),
        subProgramApi.get({ params: { perPage: -1 } })
      ])

      to.params.programs = resources[0].data
      to.params.subPrograms = resources[1].data

      next()
    }
  }
  // {
  //   path: '/subject-cores/create',
  //   name: 'subject-core-create',
  //   meta: { requiresAuth: true },
  //   component: () => import('@/pages/subject-core/create.vue'),
  //   props: route => ({
  //     programs: route.params.programs,
  //     subPrograms: route.params.subPrograms
  //   }),
  //   beforeEnter: async (to, from, next) => {
  //     let resources = await Promise.all([
  //       programApi.get({ params: { page: -1 } }),
  //       subProgramApi.get({ params: { page: -1 } })
  //     ])

  //     to.params.programs = resources[0].data
  //     to.params.subPrograms = resources[1].data

  //     next()
  //   }
  // },
  // {
  //   path: '/subject-cores/:id/edit',
  //   name: 'subject-core-edit',
  //   meta: { requiresAuth: true },
  //   component: () => import('@/pages/subject-core/edit.vue'),
  //   props: route => ({
  //     editData: route.params.editData,
  //     programs: route.params.programs,
  //     subPrograms: route.params.subPrograms
  //   }),
  //   beforeEnter: async (to, from, next) => {
  //     let resources = await Promise.all([
  //       subjectCoreApi.find(to.params.id),
  //       programApi.get({ params: { page: -1 } }),
  //       subProgramApi.get({ params: { page: -1 } })
  //     ])

  //     to.params.editData = resources[0].data
  //     to.params.programs = resources[1].data
  //     to.params.subPrograms = resources[2].data

  //     next()
  //   }
  // }
]
